<template>
  <div class="no-card-container py-5 px-7 flex">
    <img 
      src="@/assets/orderTest/checkout-page/credit-card-ban.svg" 
      alt="credit_card_banned" 
      class="w-5 h-5 mr-3"
    >
    <div>
      <p class="no-card-on-file-text">No Card on File</p>
      <div class="flex items-center no-payment-text my-1.5 break-normal whitespace-normal">
        <p>You have no payment method on file, please</p>
        <NewLibraryButton color-type="none-stroke" class="add-new-card-btn" @click="handleClickEvent" :disabled="disabled">
          add new card
        </NewLibraryButton>
      </div>
    </div>
  </div>
</template>

<script>
import NewLibraryButton from "@/NewLibrary/Button.vue";
export default {
  components: {
    NewLibraryButton
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ["click"],
  methods: {
    handleClickEvent() {
      this.$emit("click");
    }
  }
}
</script>

<style scoped>
.no-card-container {
  /* height: 80px; */
  background: #F2F2F2;
  border: 1px solid #C9CACD;
  border-radius: 2px;
}

.no-card-on-file-text {
  font-weight: 500;
  font-size: 18px;
  line-height: 21px;
}

.no-payment-text {
font-weight: 400;
font-size: 14px;
line-height: 16px;
}

.add-new-card-btn {
  margin-left: 4px;
}
</style>